import { Swiper, Pagination, Autoplay } from 'swiper'

import './vertical-auto-slider.scss'

function renderBullet(data) {
  let layout = ''

  // image
  if (data?.image.url) {
    layout += `
      <figure class="image image_fit-cover " style="--aspect-ratio: 1.3333333333333">
          <img src="${data.image.url}" alt="">
      </figure>
    `
  }

  // title
  if (data?.title) {
    layout += `
      <h5 class="heading heading_as-h5 heading_responsible-yes slider-tab__tite">
        ${data.title}
      </h5>
    `
  }

  // description
  if (data?.description) {
    layout += `
      <p class="text text_default-500 slider-tab__description">
        ${data.description}
      </p>
    `
  }

  // link
  if (data?.button?.link) {
    layout += `
      <div class="slider-tab__button">
        <a class="button button_variant-tertiary button_scheme-light" href="${data.button.link.url}" target="${data.button.link.target}" data-vs-link>
          <span class="button__label">${data.button.link.title}</span>
            <span class="button__icon">
              <svg class="icon" width="16" height="16" 
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6665 12L10.6665 8L6.6665 4"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="square"
                      stroke-linejoin="round" />
              </svg>
            </span>
          </a>
        </div>
    `
  }

  return layout
}

const init = () => {
  Swiper.use([Autoplay, Pagination])

  const sliders = document.querySelectorAll('.vertical-auto-slider')

  Array.from(sliders).map((slider) => {
    const el = slider.querySelector('.vertical-auto-slider__slider')
    const navigation = slider.querySelector('.vertical-auto-slider__navigation')

    navigation?.addEventListener('click', (e) => {
      if (e.target.matches('[data-vs-link]')) {
        if (e.target.target === '_blank') {
          window.open(e.target.href)
        } else {
          window.location.assign(e.target.href)
        }
      }
    })

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 0,

      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      pagination: {
        el: navigation,
        clickable: true,
        waitForTransition: false,

        renderBullet: function (index, className) {
          const data = JSON.parse(this.el.dataset.pagination) || []

          return `
          <div class="slider-tab ${className}">
            <p class="text text_default-500">
              ${index >= 10 ? index + 1 : `0${index + 1}`}.
            </p>
            <div class="slider-tab__info">
              ${renderBullet(data[index])}
            </div>
          </div>`
        },
      },
    })
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  init()
})
